import { uuidv7 } from "uuidv7";
import api from "api";
import { mediaApiBase } from "api/constants";

const EXTENSION_BY_MIME: Record<string, string> = {
  "video/mp4": ".mp4",
  "text/vtt": ".vtt",
  "image/svg+xml": ".svg",
  "image/gif": ".gif",
  "image/jpeg": ".jpg",
  "image/png": ".png",
};

const uploadFile = async (file: File, language?: string) => {
  const ext = EXTENSION_BY_MIME[file.type];
  if (!ext) throw new Error(`Unsupported file type: ${file.type}`);
  if (file.type === "text/vtt" && !language) {
    throw new Error("Language is required for caption files");
  }
  const fileName = uuidv7() + ext;

  // @ts-ignore
  const fileUploadConfig = await api.parse(`POST /exercises/upload/presign`, {
    root: mediaApiBase,
    data: {
      content_type: file.type,
      file_name: fileName,
      scope: "joint_academy",
      caption_language: language,
    },
  });

  // @ts-ignore
  const fileUploadUrl: string = fileUploadConfig.upload_url;
  // @ts-ignore
  const fileUploadValues: Record<string, string> = fileUploadConfig.upload_fields;
  // @ts-ignore
  const fileUrl: string = fileUploadConfig.object_url;

  const formData = new FormData();
  Object.entries(fileUploadValues).forEach(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("file", file, fileName);

  const fileUploadResponse = await fetch(fileUploadUrl, {
    method: "POST",
    body: formData,
    headers: { Accept: "application/json" },
  });
  if (!fileUploadResponse.ok) {
    throw new Error(`Upload failed: ${fileUploadResponse.status} ${fileUploadResponse.statusText}`);
  }

  return fileUrl;
};
export default uploadFile;
